import { Component, ComponentFactoryResolver, ComponentRef, OnDestroy, OnInit, Type, ViewChild, ViewContainerRef, inject } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router, UrlSegment } from '@angular/router';
import { TranslateService, isArray } from '@ngx-translate/core';
import { NetworkConstants, GameRecord, Person, HuntingEvent, LaboratorySample, HuntingDistrict, ContextMembership, GameCollectStation, PointOfInterest, Trophy, Digatag, LifeSign, DefaultIconsPoiMapping, removeUndefined, deepCopy, dataToObject, UserRoles } from 'diwimamodelweb/lib';
import { BehaviorSubject, Observable, from, of, throwError, tap, Subject, Subscription } from 'rxjs';
import { catchError, filter, map, mergeMap, skipWhile, take, takeUntil } from 'rxjs/operators';
import { getCurrentJagdJahr } from 'src/app/cockpit/statistics/filter.service';
import { EventsService } from '../events.service';
import { FilterListComponent } from '../filter-list/filter-list.component';
import { GenericGridListComponent } from '../generic-grid-list/generic-grid-list.component';
import { UserMultiEditDialogComponent } from '../user-multi-edit-dialog/user-multi-edit-dialog.component';
import { FormDialogComponent } from '../form-dialog/form-dialog.component';
import { UserGroupsService } from '../../cockpit/us-managment/user-groups.service';
import { GameCollectStationService } from '../game-collect-station.service';
import { GamerecordService } from '../gamerecord.service';
import { HuntingDistrictService } from '../hunting-district.service';
import { InjectComponentDirective } from '../inject-component.directive';
import { LabSampleService } from '../lab-sample.service';
import { Form, FormListener, GameCollectStationForm, GameRecordForm, HuntingDistrictForm, HuntingEventForm, InviteUserForm, LaboratorySampleForm, PersonForm, PointOfInterestForm, TrophyForm, UserForm } from '../model/form';
import { GameRecordListItem, GenericListItem, ListItem, ListItemListener, SelectableListItem, PoiListItem, GenericListItemDisabled } from '../model/list';
import { NavListItemComponent } from '../nav-list-item/nav-list-item.component';
import { PersonService } from '../person.service';
import { PoiService } from '../poi.service';
import { SettingsService } from '../settings.service';
import { TransactionLogService } from '../transaction-log.service';
import { TrophyService } from '../trophy.service';
import { UserFeedbackService } from '../user-feedback.service';
import { anyToUser } from '../utils/utils';
import { Firestore, collection, collectionGroup, doc, getDoc, getDocs, limit, or, orderBy, query, startAfter, where } from '@angular/fire/firestore';
import { HuntingDistrictListDialogComponent } from '../hunting-district-list-dialog/hunting-district-list-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { UserService } from '../user.service';
import { GenericDialogComponent } from '../generic-dialog/generic-dialog.component';

// important for poi custom role filter
import { WorkOrderService } from 'src/app/shared/work-orders.service';
import { CREATED_BY_USER, LINKED_IN_WORK_ORDERS, applyHuntingDistrictRightsFilter } from '../rights-filters.util';
import { UserNameLookupService } from 'src/app/cockpit/work-orders/user-name-lookup.service';

/**
 * Component for handling swapping in desired views. Template contains a `<ng-template injectComp></ng-template>`
 * This is the root for holding "generic" views. 
 */
@Component({
  selector: 'app-component-handler',
  templateUrl: './component-handler.component.html',
  styleUrls: ['./component-handler.component.css', '../../app.component.scss']
})
export class ComponentHandlerComponent implements OnInit, ListItemListener, FormListener,OnDestroy {

  // used for poi custom role filter
  private rawItems = new Map<string, ListItem[]>();
  private linkedIdsByType: Record<string, Set<string>> = {
    geoObject: new Set<string>(),
    gameRecord: new Set<string>(),
  };
  private allWorkOrders: any[] = [];

  private rebuildLinkedIds(): void {
    const next: Record<string, Set<string>> = { geoObject: new Set(), gameRecord: new Set() };
    const uid = this.subbedContext?.userId;

    (this.allWorkOrders ?? [])
      .filter(o => !!uid && (o.targetUserIds ?? []).includes(uid))
      .forEach(o => {
        const [type, id] = (o.link ?? '').split(':');
        if (type && id && next[type]) next[type].add(id);
      });

    this.linkedIdsByType = next;
  }

  private Ifirestore = inject(Firestore);
  currentObjectId: BehaviorSubject<UrlSegment[]|undefined> = new BehaviorSubject(undefined)
  showBack = false
  showCreate = false

  formTitle = new BehaviorSubject<string>("Form")

  @ViewChild(InjectComponentDirective, {static: true}) view: InjectComponentDirective;

  componentRef: ComponentRef<any>|undefined = undefined
  viewContainerRef: ViewContainerRef|undefined = undefined 

  // observable list item data
  listItems$: BehaviorSubject<ListItem[]|undefined> = new BehaviorSubject(undefined)
  activeObjectId$: BehaviorSubject<string> = new BehaviorSubject(undefined)
  listItemsWithLimit$: BehaviorSubject<ListItem[]|undefined> = new BehaviorSubject(undefined)
  documentDataForm$: BehaviorSubject<Form|undefined> = new BehaviorSubject(undefined)
  allUsersList:any = []
  allUsersIDList:any = []
  subbedContext: ContextMembership|undefined = undefined
  checkingContextIdSubcontextIds: string|undefined = undefined

  activeForm: Form|null = null
  loadingPagination:boolean = false
  allGeoTypes: any[]
  allUsersOfContextId: any[]
  listUsers$: BehaviorSubject<ListItem[]|undefined> = new BehaviorSubject(undefined)
  listMembershipsOfContextId$: BehaviorSubject<ListItem[]|undefined> = new BehaviorSubject([])
  listItemsFromLimits$ = new Map<string, ListItem[]|undefined>();
  lastListItem$: BehaviorSubject<any|undefined> = new BehaviorSubject(
    {
      [NetworkConstants.COLLECTION_USER]:undefined,//[],
      [NetworkConstants.COLLECTION_HUNTING_DISTRICT]:undefined,//[],
      [NetworkConstants.COLLECTION_GAME_COLLECT_STATION]:undefined,//[],
      [NetworkConstants.COLLECTION_EVENT]:undefined,//[],
      [NetworkConstants.COLLECTION_PERSON]:undefined,//[],
      [NetworkConstants.COLLECTION_DIGATAG]:undefined,//[],
      [NetworkConstants.COLLECTION_GAMERECORD]:undefined,//[],
      [NetworkConstants.COLLECTION_POI]:undefined,//[],
      [NetworkConstants.COLLECTION_LABSAMPLE]:undefined,//[],
      [NetworkConstants.COLLECTION_TROPHY]:undefined,//[],
      [NetworkConstants.COLLECTION_LIFE_SIGN]:undefined//[]
    }
  )

  listItemsUser$: BehaviorSubject<ListItem[]|undefined> = new BehaviorSubject(undefined)
  listItemsHD$: BehaviorSubject<ListItem[]|undefined> = new BehaviorSubject(undefined)
  listItemsGCS$: BehaviorSubject<ListItem[]|undefined> = new BehaviorSubject(undefined)
  listItemsEvent$: BehaviorSubject<ListItem[]|undefined> = new BehaviorSubject(undefined)
  listItemsPerson$: BehaviorSubject<ListItem[]|undefined> = new BehaviorSubject(undefined)
  listItemsDigaTag$: BehaviorSubject<ListItem[]|undefined> = new BehaviorSubject(undefined)
  listItemsGR$: BehaviorSubject<ListItem[]|undefined> = new BehaviorSubject(undefined)
  listItemsPOI$: BehaviorSubject<ListItem[]|undefined> = new BehaviorSubject(undefined)
  listItemsLabSamp$: BehaviorSubject<ListItem[]|undefined> = new BehaviorSubject(undefined)
  listItemsTroph$: BehaviorSubject<ListItem[]|undefined> = new BehaviorSubject(undefined)
  listItemsLifeSign$: BehaviorSubject<ListItem[]|undefined> = new BehaviorSubject(undefined)

  subscriptions: Map<string,Subscription> = new Map([])

  allStates = []

  mapToObserve = new Map([
    [NetworkConstants.COLLECTION_USER, this.listItemsUser$],
    [NetworkConstants.COLLECTION_HUNTING_DISTRICT, this.listItemsHD$],
    [NetworkConstants.COLLECTION_GAME_COLLECT_STATION,this.listItemsGCS$],
    [NetworkConstants.COLLECTION_EVENT,this.listItemsEvent$],
    [NetworkConstants.COLLECTION_PERSON,this.listItemsPerson$],
    [NetworkConstants.COLLECTION_DIGATAG,this.listItemsDigaTag$],
    [NetworkConstants.COLLECTION_GAMERECORD,this.listItemsGR$],
    [NetworkConstants.COLLECTION_POI,this.listItemsPOI$],
    [NetworkConstants.COLLECTION_LABSAMPLE,this.listItemsLabSamp$],
    [NetworkConstants.COLLECTION_TROPHY,this.listItemsTroph$],
    [NetworkConstants.COLLECTION_LIFE_SIGN,this.listItemsLifeSign$]
  ])
  private destroy$ = new Subject<void>();
  private objectIdChange$ = new Subject<string>();

  constructor(
    private route: ActivatedRoute,
    private componentFactoryResolver: ComponentFactoryResolver,
    private settingsService: SettingsService,
    private router: Router,
    private formBuilder: FormBuilder,
    private userFeedbackService: UserFeedbackService,
    private personService: PersonService,
    private gamerecordService: GamerecordService,
    private huntingDistrictService: HuntingDistrictService,
    private eventsService: EventsService,
    private poiService: PoiService,
    private translateService: TranslateService,
    private transactionLogService: TransactionLogService,
    private labSampleService: LabSampleService,
    private gameCollectStationService: GameCollectStationService,
    private trophyService: TrophyService,
    private dialog: MatDialog,
    private userService: UserService,
    private workOrderService: WorkOrderService,
    private usGroupService: UserGroupsService,
    private userNameLookup: UserNameLookupService
  ) {
    this.route.url.subscribe((url) => {
      this.currentObjectId.next(url)
    })
    this.currentObjectId.next(this.route.snapshot.url)
   }

   ngOnInit(): void {
    // Needed by the user-list filters
    this.userService.user$
      .pipe(takeUntil(this.destroy$))
      .subscribe(user => { this.currentUserDoc = user })

    this.currentObjectId.subscribe((url) => {
      if (this.viewContainerRef?.length > 0) {
        this.viewContainerRef.clear()
      }
      this.settingsService.selectedUserContext$
        .pipe(skipWhile((el) => !el), take(1))
        .subscribe((context: ContextMembership) => {
          // if (context.identifier == this.subbedContext?.identifier) return 
          this.injectAppropriateView(context.identifier, url, context)
          this.subbedContext = context
          const superOrsubContext = this.settingsService.superContext.value || this.settingsService.subContext.value

          if (superOrsubContext) {
           this.checkingContextIdSubcontextIds = superOrsubContext ? (this.settingsService.selectedContextAndSubContextIds.value ?? []).join(',') : context?.identifier
          }
        })
    })

    this.settingsService.selectedContextAndSubContextIds
    .pipe(skipWhile((el) => !el))
    .subscribe(( ids ) => {
      const context = this.settingsService.selectedUserContext$.value
      const url = this.currentObjectId.value
      // console.log('--- change on supercontext ids ---> reload list for', ids,  context?.identifier, url)
      this.injectAppropriateView(context.identifier, url, context)
    })

    this.workOrderService.allOrders$
    .pipe(takeUntil(this.destroy$))
    .subscribe(orders => {
      this.allWorkOrders = orders ?? [];
      this.rebuildLinkedIds();

      const active = this.activeObjectId$.value;
      const ctxId = this.subbedContext?.identifier;
      if (ctxId && active === NetworkConstants.COLLECTION_POI) {
        this.setListItems(active, this.rawItems.get(active) ?? [], ctxId);
      }
    });

    this.activeObjectId$
    .pipe(
      skipWhile((el) => !el),
      // take(1),
    ) .subscribe( value => {
      // console.log('--- active ObjectId change ---', value)
      this.objectIdChange$.next(value)
    })

    this.listItems$
      .pipe(
        skipWhile((el) => !el),
        // take(1),
      )
      .subscribe(async (items: ListItem[]) => {
        const activeObjectIdForList = this.activeObjectId$.value
        const isUserOrPersonOrEventGrid = activeObjectIdForList === NetworkConstants.COLLECTION_USER
          || activeObjectIdForList === NetworkConstants.COLLECTION_PERSON || activeObjectIdForList === NetworkConstants.COLLECTION_EVENT
        if (this.viewContainerRef?.length > 0) this.viewContainerRef.clear()
        this.viewContainerRef = this.view.viewContainerRef
        const listComponentType: Type<any> = isUserOrPersonOrEventGrid ? GenericGridListComponent : FilterListComponent
        this.componentRef = this.viewContainerRef.createComponent(listComponentType)
        if (activeObjectIdForList === NetworkConstants.COLLECTION_USER) {
          this.componentRef.instance.columnDefs = this.userGridColumnDefs()
          this.ensureUserGroupsLoaded()
          // Groups may still be loading when the grid first renders — refresh
          // once they're in so the "Gruppen" column actually populates.
          this.usGroupService.allAssignableUserGroupsSubject$
            .pipe(skipWhile(v => !v), take(1))
            .subscribe(() => { if (this.componentRef?.instance) this.componentRef.instance.data = items })
        } else if (activeObjectIdForList === NetworkConstants.COLLECTION_PERSON) {
          this.componentRef.instance.columnDefs = this.personGridColumnDefs()
        } else if (activeObjectIdForList === NetworkConstants.COLLECTION_EVENT) {
          this.componentRef.instance.columnDefs = this.eventGridColumnDefs()
        }
        if (items[0]?.className == GameRecordListItem.className) {
          this.componentRef.instance.showAdd = false
          const context = await this.settingsService.selectedUserContext$.pipe(
            skipWhile(el => !el),
            take(1)
          ).toPromise()
          const species = context.settingsMap.get(NetworkConstants.SETTING_SPECIES).values
          items.forEach((item: GameRecordListItem) => {
            const {wildart} = item.data
            if (!wildart) return 
            const ind = species.findIndex(el => el.identifier == wildart)
            if (ind != -1) item.iconName = species[ind].iconName
          })
        }
        if (items[0]?.name == NetworkConstants.COLLECTION_LABSAMPLE) {
          this.componentRef.instance.showAdd = false
        }
        if (items[0]?.className == PoiListItem.className) {
          this.componentRef.instance.showAdd = false
        }
        if (items[0]?.name == NetworkConstants.COLLECTION_TROPHY) {
          this.componentRef.instance.showAdd = false
        }
        if (items[0]?.name == NetworkConstants.COLLECTION_LIFE_SIGN) {
          this.componentRef.instance.showAdd = false
        }

        const activeObjectId = this.activeObjectId$.value
        if (activeObjectId && !this.hasRight(this.currentRights(), activeObjectId, 'C')) {
          this.componentRef.instance.showAdd = false
        }

        this.componentRef.instance.loadingPagination = this.loadingPagination

        this.componentRef.instance.data = items
        this.componentRef.instance.addItem.subscribe(() => {
          if (isUserOrPersonOrEventGrid) {
            this.openGridItemFormDialog(activeObjectIdForList, undefined)
            return
          }
          // add document type
          this.router.navigate(['create'], {relativeTo: this.route})
        })

        this.componentRef.instance.addItemFromList.subscribe(() => {
          //console.log('---select from list')

          let list = []
          if(!this.huntingDistrictService.allAuthoritiesVeterinary$.value )
            this.huntingDistrictService.getVeterinaryAuthorityList()
          else{
            let list = this.huntingDistrictService.allAuthoritiesVeterinary$.value
            this.openDialogVets(list)
          }

          this.huntingDistrictService.allAuthoritiesVeterinary$.subscribe( vets => {
            list = vets?.filter(vet => vet.huntingDistrictList === true)?.sort((a,b) => a?.name?.localeCompare(b.name));
          })
        })

        if (activeObjectIdForList === NetworkConstants.COLLECTION_USER
          && this.hasRight(this.currentRights(), NetworkConstants.COLLECTION_USER, 'U')) {
          this.componentRef.instance.showMultiEdit = true
          this.componentRef.instance.multiEditLabelKey = 'COCKPIT.TAB_NAV.ASSIGN_GROUPS'
          this.componentRef.instance.multiEdit.subscribe((selectedItems: ListItem[]) => {
            const users = selectedItems.map(i => i.data)
            const dialogRef = this.dialog.open(UserMultiEditDialogComponent, {
              data: { users },
              minWidth: '40vw',
            })
            dialogRef.afterClosed().subscribe((saved: boolean) => {
              if (saved) this.currentObjectId.next(this.route.snapshot.url)
            })
          })
        }
      })
    this.documentDataForm$
    .pipe(skipWhile((el) => !el))
    .subscribe(
       (form) => {
        if (this.viewContainerRef?.length > 0) this.viewContainerRef.clear()
        this.viewContainerRef = this.view.viewContainerRef
        this.componentRef = this.viewContainerRef.createComponent(form.componentRef)
        this.componentRef.instance.data = form
        this.componentRef.instance.formBuilder = this.formBuilder
        this.componentRef.instance.userFeedbackService = this.userFeedbackService
        this.componentRef.instance.translateService = this.translateService
        if(form.className == UserForm.className) {
          const t = this.translateService.instant('COCKPIT.OBJECTS.User')
          this.formTitle.next(t?t:this.formTitle.value)
          this.componentRef.instance.objectService = this.personService
        } else if (form.className == PersonForm.className) {
          const t = this.translateService.instant('COCKPIT.OBJECTS.Person')
          this.formTitle.next(t?t:this.formTitle.value)
          this.componentRef.instance.objectService = this.personService
          this.componentRef.instance.setSettingsService(this.settingsService)
        } else if (form.className == GameRecordForm.className) {
          const t = this.translateService.instant('COCKPIT.OBJECTS.GameRecord')
          this.formTitle.next(t?t:this.formTitle.value)
          this.showBack = false
          this.componentRef.instance.objectService = this.gamerecordService
          this.componentRef.instance.componentFactoryResolver = this.componentFactoryResolver
          // this.componentRef.instance.transactionLogService = this.transactionLogService
        } else if (form.className == HuntingEventForm.className) {
          const t = this.translateService.instant('COCKPIT.OBJECTS.Event')
          this.formTitle.next(t?t:this.formTitle.value)
          this.componentRef.instance.objectService = this.eventsService
        } else if (form.className == LaboratorySampleForm.className) {
          const t = this.translateService.instant(`COCKPIT.OBJECTS.${NetworkConstants.COLLECTION_LABSAMPLE}`)
          this.formTitle.next(t?t:this.formTitle.value)
          this.componentRef.instance.objectService = this.labSampleService
        } else if (form.className == HuntingDistrictForm.className) {
          const t = this.translateService.instant(`COCKPIT.OBJECTS.${NetworkConstants.COLLECTION_HUNTING_DISTRICT}`)
          this.formTitle.next(t?t:this.formTitle.value)
          this.componentRef.instance.objectService = this.huntingDistrictService
          this.componentRef.instance.router = this.router
          this.componentRef.instance.route = this.route
        } else if (form.className == GameCollectStationForm.className) {
          const t = this.translateService.instant(`COCKPIT.OBJECTS.${NetworkConstants.COLLECTION_GAME_COLLECT_STATION}`)
          this.formTitle.next(t?t:this.formTitle.value)
          this.componentRef.instance.objectService = this.gameCollectStationService
        } else if (form.className == PointOfInterestForm.className) {
          const t = this.translateService.instant(`COCKPIT.OBJECTS.${NetworkConstants.COLLECTION_POI}`)
          this.formTitle.next(t?t:this.formTitle.value)
          this.componentRef.instance.objectService = this.poiService
          this.showBack = false
          this.componentRef.instance.componentFactoryResolver = this.componentFactoryResolver
          
        } else if (form.className == TrophyForm.className) {
          const t = this.translateService.instant(`COCKPIT.OBJECTS.${NetworkConstants.COLLECTION_TROPHY}`)
          this.formTitle.next(t?t:this.formTitle.value)
          this.componentRef.instance.objectService = this.trophyService
        }
        this.activeForm = form
      }
    )

    this.settingsService.selectedUserContext$.value.settingsMap.forEach( el => {
      if(el.identifier== NetworkConstants.SETTING_GEO_TYPE){
        this.allGeoTypes=el.values

      }
    })

    //--------------states
    this.huntingDistrictService.allStates$.subscribe(value => {
      this.allStates = value
    })
  }

  ngOnDestroy() {
    console.log('---destroy---')
    this.listItems$.value?.forEach((el) => {el.removeListener(this)})
    this.lastListItem$.next( {
      [NetworkConstants.COLLECTION_USER]:undefined,//[],
      [NetworkConstants.COLLECTION_HUNTING_DISTRICT]:undefined,//[],
      [NetworkConstants.COLLECTION_GAME_COLLECT_STATION]:undefined,//[],
      [NetworkConstants.COLLECTION_EVENT]:undefined,//[],
      [NetworkConstants.COLLECTION_PERSON]:undefined,//[],
      [NetworkConstants.COLLECTION_DIGATAG]:undefined,//[],
      [NetworkConstants.COLLECTION_GAMERECORD]:undefined,//[],
      [NetworkConstants.COLLECTION_POI]:undefined,//[],
      [NetworkConstants.COLLECTION_LABSAMPLE]:undefined,//[],
      [NetworkConstants.COLLECTION_TROPHY]:undefined,//[],
      [NetworkConstants.COLLECTION_LIFE_SIGN]:undefined//[]
    })
    this.destroy$.next();
    this.destroy$.complete();
    this.mapToObserve.forEach((value, key) => {
      value.next(undefined)
      this.removeSubs(value)
    })
  }

  async injectAppropriateView(contextId: string, url: UrlSegment[], context) {
    if (!url || url.length == 0) {
      console.error("Nothing to inject returning")
      return
    }
    const objectId = url[0].path

    if(objectId!=this.activeObjectId$.value){
      // this.removeSubs(objectId)
      if (this.subscriptions.get(objectId)) this.subscriptions.get(objectId).unsubscribe()
      this.activeObjectId$.next(objectId)
    }
    const documentId: string|undefined = url[1]?.path
    if (!documentId) {
      this.showCreate = true
      this.showBack = false 
    } else {
      this.showBack = true
      this.showCreate = false
    }
    const rightsPercontext = this.settingsService.rightsPercontext.get(contextId)

    if (!this.hasRight(rightsPercontext, objectId, 'R')) {
      this.showNoRightsDialog()
      this.listItems$.next([])
      return
    }

    if (documentId == "create" && !this.hasRight(rightsPercontext, objectId, 'C')) {
      this.showNoRightsDialog()
      return this.router.navigate(['..'], {relativeTo: this.route})
    }

    const superOrsubContext = context.superContextIds || context.subContextIds

    // decide what to display
    switch(objectId) {
      case NetworkConstants.COLLECTION_PERSON: {
        if (!documentId) {
          // this.loadListData(contextId, objectId)
          //   .subscribe((data) => {this.listItems$.next(data)})

          const listwithLimit = this.loadListDataWithLimit(contextId, objectId)
          .pipe(takeUntil(this.destroy$)).subscribe( )

          this.subscriptions.set(objectId, listwithLimit)

          this.listItemsPerson$
          .pipe(skipWhile((el) => !el),takeUntil(this.destroy$) )
          .subscribe(items => {
            this.listItems$.next(items)
          });
        } else {
          // if specific document is selected.. 
          // show form of document and register back button click callback
          if (documentId == "create") {
            const form = new PersonForm("Create Person", undefined)
            form.addListener(this)
            this.documentDataForm$.next(form)
          } else {
            this.loadDocumentData(objectId, documentId)
              .subscribe((element: any) => {
                if (!element) return this.router.navigate(['..'], {relativeTo: this.route})
                const person = new Person()//anyToPerson(element)
                person.setFromAny(element)
                const form = new PersonForm("PersonForm", person)
                form.addListener(this)
                this.documentDataForm$.next(form)
                // this.componentRef.instance.data = form
              })
          }
        }
        break
      }
      case NetworkConstants.COLLECTION_EVENT: {
        if (!documentId) {
          // create ... 
          // this.loadListData(contextId, objectId)
          //   .subscribe((data) => {this.listItems$.next(data)})
          const listwithLimit = this.loadListDataWithLimit(contextId, objectId)
          .pipe(takeUntil(this.destroy$)).subscribe( )

          this.subscriptions.set(objectId, listwithLimit)

          this.listItemsEvent$
          .pipe(skipWhile((el) => !el),takeUntil(this.destroy$) )
          .subscribe(items => {
            // console.log(items?.length,'----> update listItemsEvent ---> inject comp' )
            this.listItems$.next(items)
          });
        } else {
          const huntingDistricts = this.allowedHuntingDistrictsFor(contextId, await this.huntingDistrictService.huntindDistrictSubject$.pipe(skipWhile(el => !el), take(1)).toPromise())
          if (documentId == "create") {
            const form = new HuntingEventForm(
              "Create Event",
              huntingDistricts,
              undefined
            )
            form.addListener(this)
            this.documentDataForm$.next(form)
          } else {
            this.loadDocumentData(objectId, documentId).subscribe(
              (element) => {
                if (!element) return this.router.navigate(['..'], {relativeTo: this.route})
                const event = new HuntingEvent()
                event.setFromAny(element)
                const form = new HuntingEventForm(
                  "Event",
                  huntingDistricts,
                  event
                )
                form.addListener(this)
                this.documentDataForm$.next(form)
              }
            )
          }
        }
        break
      }
      case NetworkConstants.COLLECTION_GAMERECORD: {
        if (!documentId) {

          if (superOrsubContext) {
            // Results reach listItems$ through setListItems() → listItems<Type>$,
            // which is where the rights filters are applied. Pushing the returned
            // list here too would overwrite the filtered result with the raw one.
            this.loadListDataContextAndContextIds(contextId, objectId, context)
          } else {
            const listwithLimit = this.loadListDataWithLimit(contextId, objectId)
                                      .pipe(takeUntil(this.destroy$)).subscribe( )
            this.subscriptions.set(objectId, listwithLimit)
          }

          this.listItemsGR$
          .pipe(skipWhile((el) => !el),takeUntil(this.destroy$) )
          .subscribe(items => {
            // console.log(items?.length,'----> update listItemsGR ---> inject comp' )
            this.listItems$.next(items)
          });
        } else {
          if(!rightsPercontext?.[NetworkConstants.COLLECTION_GAMERECORD]?.['R']) {
            this.showNoRightsDialog()
            return;
          }

          const context = await this.settingsService.selectedUserContext$.pipe(
            skipWhile(el => !el),
            take(1)
          ).toPromise()
          let person = []
          let events = []
          let huntingDistricts = []
          let poi = []

          if( this.personService.personSubject$.value)
           person = await this.personService.personSubject$.pipe(skipWhile(el => !el), take(1)).toPromise()

          if(this.huntingDistrictService.huntindDistrictSubject$.value)
           huntingDistricts = this.allowedHuntingDistrictsFor(contextId, await this.huntingDistrictService.huntindDistrictSubject$.pipe(skipWhile(el => !el), take(1)).toPromise())
          
          if(this.eventsService.eventsSubject$.value)
            events = await this.eventsService.eventsSubject$.pipe(skipWhile(el => !el), take(1)).toPromise()
          
          if( this.poiService.poiSubject$.value)
           poi = await this.poiService.poiSubject$.pipe(skipWhile(el => !el), take(1)).toPromise()
         
          if (documentId == "create") {
            const form = new GameRecordForm(
              "Create GameRecord",
              context.settingsMap,
              context.modulesMap,
              person, 
              poi,
              huntingDistricts,
              events,
              undefined
            )
            this.documentDataForm$.next(form)
          } else {
            this.loadDocumentData(objectId, documentId)
              .subscribe(async (element: any) => {
                if (!element) return this.router.navigate(['..'], {relativeTo: this.route})
                const gr = new GameRecord(this.settingsService.selectedUserContext$.value)
                gr.setFromAny(element)
                const context = await this.settingsService.selectedUserContext$.pipe(
                  skipWhile(el => !el),
                  take(1)
                ).toPromise()
                const form = new GameRecordForm(
                  "GameRecord", 
                  context.settingsMap,
                  context.modulesMap,
                  person, 
                  poi,
                  huntingDistricts,
                  events,
                  gr
                )
                form.addListener(this)
                this.documentDataForm$.next(form)
              })
          }
        }

        break
      }
      case NetworkConstants.COLLECTION_GAME_COLLECT_STATION: {
        if (!documentId) {
          // this.loadListData(contextId, objectId)
          //   .subscribe((data) => {this.listItems$.next(data)})

          const listwithLimit = this.loadListDataWithLimit(contextId, objectId)
          .pipe(takeUntil(this.destroy$)).subscribe( )

          this.subscriptions.set(objectId, listwithLimit)

          this.listItemsGCS$
          .pipe(skipWhile((el) => !el),takeUntil(this.destroy$) )
          .subscribe(items => {
            // console.log(items?.length,'----> update listItemsGCS ---> inject comp' )
            this.listItems$.next(items)
          });

        } else {
          const huntingDistricts = this.allowedHuntingDistrictsFor(contextId, await this.huntingDistrictService.huntindDistrictSubject$.pipe(skipWhile(el => !el), take(1)).toPromise())
          if (documentId == "create") {
            const form = new GameCollectStationForm(
              "Create GameRecord",
              huntingDistricts,
              undefined
            )
            form.addListener(this)
            this.documentDataForm$.next(form)
          } else {
            this.loadDocumentData(objectId, documentId)
              .subscribe(async (element: any) => {
                if (!element) return this.router.navigate(['..'], {relativeTo: this.route})
                const gameCollectStation = new GameCollectStation()
                gameCollectStation.setFromAny(element)
                const form = new GameCollectStationForm(
                  "Create GameRecord",
                  huntingDistricts,
                  gameCollectStation
                )
                form.addListener(this)
                this.documentDataForm$.next(form)
              })
          }
        }
        break
      }

      case NetworkConstants.COLLECTION_POI: {
        if (!documentId) {
          if (rightsPercontext?.[NetworkConstants.COLLECTION_POI]?.filters?.includes(LINKED_IN_WORK_ORDERS)) {
            this.workOrderService.observeData(contextId)
          }

          if (superOrsubContext) {
            // Results reach listItems$ through setListItems() → listItems<Type>$,
            // which is where the rights filters are applied. Pushing the returned
            // list here too would overwrite the filtered result with the raw one.
            this.loadListDataContextAndContextIds(contextId, objectId, context)
          } else {
            const a = this.loadListDataWithLimit(contextId, objectId)
            .pipe(takeUntil(this.destroy$)).subscribe( )
  
            if(!this.subscriptions.get(objectId))
              this.subscriptions.set(objectId, a)
          }

          this.listItemsPOI$
          .pipe(skipWhile((el) => !el),takeUntil(this.destroy$) )
          .subscribe(items => {
            // console.log(items?.length,'----> update listItemsPOI ---> inject comp' )
            this.listItems$.next(items)
          });

        } else {
          if(!rightsPercontext?.[NetworkConstants.COLLECTION_POI]?.['R']) {
            this.showNoRightsDialog()
            return;
          }

          const huntingDistricts = this.allowedHuntingDistrictsFor(contextId, await this.huntingDistrictService.huntindDistrictSubject$.pipe(skipWhile(el => !el), take(1)).toPromise())
          const context = await this.settingsService.selectedUserContext$.pipe(
            skipWhile(el => !el),
            take(1)
          ).toPromise()
          if (documentId == "create") {
            // impossible??
            return this.router.navigate(['..'], {relativeTo: this.route})
          } else {
            this.loadDocumentData(objectId, documentId)
              .subscribe(async (element: any) => {
                if (!element) return this.router.navigate(['..'], {relativeTo: this.route})
                const poi = new PointOfInterest()
                poi.setFromAny(element)
                
                const form = new PointOfInterestForm(
                  "poiForm",
                  context.settingsMap,
                  huntingDistricts,
                  poi
                )
                form.addListener(this)
                this.documentDataForm$.next(form)
              })
          }
        }
        break
      }

      case NetworkConstants.COLLECTION_USER: {
        if (!documentId) {
          this.allUsersList = []
          this.allUsersIDList = []
          this.listMembershipsOfContextId$.next([])
          this.listItems$.next([]);
          
          const userContextIds = this.userContextIds(contextId, context)

          this.loadUsersListData(userContextIds, objectId)
            .subscribe((data:any) => {
              this.listItems$.next(this.filterUsersByRights(this.listMembershipsOfContextId$.value));
            })

            //add this to load user with old collection contextmembership
          this.loadUsersListDataFromContextMembership(userContextIds, objectId).subscribe( data => { this.listItems$.next(this.filterUsersByRights(this.listMembershipsOfContextId$.value)); })
        } else {
          // load specific UserForm...
          if (documentId == "create") {
            const form = new InviteUserForm("Create User", undefined)
            form.addListener(this)
            this.documentDataForm$.next(form)
            const t = await this.translateService.get(`COCKPIT.OBJECTS.inviteUser`).toPromise()
            this.formTitle.next(t?t:this.formTitle.value)

          } else {
            this.loadDocumentData(objectId, documentId)
              .subscribe((element: any) => {
                // todo!!
                if (!element) return this.router.navigate(['..'], {relativeTo: this.route})
                if(!element.identifier)
                element.identifier = documentId
                const user = anyToUser(element)
                const form = new UserForm("UersonForm", user)
                form.addListener(this)
                this.documentDataForm$.next(form)
              })
          }
        }
        break
      }
      case NetworkConstants.COLLECTION_LABSAMPLE: {
        if (!documentId) {

          if (superOrsubContext) {
            this.loadListDataContextAndContextIds(contextId, objectId, context)
          } else {
            const listwithLimit = this.loadListDataWithLimit(contextId, objectId)
                                      .pipe(takeUntil(this.destroy$)).subscribe( )
            this.subscriptions.set(objectId, listwithLimit)
          }


          this.listItemsLabSamp$
          .pipe(skipWhile((el) => !el),takeUntil(this.destroy$) )
          .subscribe(items => {
            // console.log(items?.length,'----> update listItemsLabSample ---> inject comp', items )
            this.listItems$.next(items)
          });
        } else {
          this.loadDocumentData(objectId, documentId)
              .subscribe((element: any) => {
                if (!element) return this.router.navigate(['..'], {relativeTo: this.route})
                const context = this.settingsService.selectedUserContext$.value
                const labSample = new LaboratorySample(context)
                labSample.setFromAny(element)
                const form = new LaboratorySampleForm(
                  "LabSampleForm",
                  context.settingsMap,
                  labSample,
                )
                form.addListener(this)
                this.documentDataForm$.next(form)
              })
        }
        break
      }
      case NetworkConstants.COLLECTION_HUNTING_DISTRICT: {
        this.huntingDistrictService.getVeterinaryAuthorityList()
        this.huntingDistrictService.getHuntingAuthorityList()
        if (!documentId) {
          if (superOrsubContext) {
            this.loadListDataContextAndContextIds(contextId, objectId, context)
          } else {
            const listwithLimit = this.loadListDataWithLimit(contextId, objectId)
            .pipe(takeUntil(this.destroy$)).subscribe( )
  
            this.subscriptions.set(objectId, listwithLimit)
          }

          this.listItemsHD$
          .pipe(skipWhile((el) => !el),takeUntil(this.destroy$) )
          .subscribe(items => {
            // console.log(items?.length,'----> update listItemsHD ---> inject comp' )
            this.listItems$.next(items)
          });
        } else {
          if (documentId == "create") {
            if (!rightsPercontext?.[NetworkConstants.COLLECTION_HUNTING_DISTRICT]?.['C']) {
              this.showNoRightsDialog()
              return this.router.navigate(['..'], {relativeTo: this.route})
            }
            const form = new HuntingDistrictForm("Create Hunting District", undefined)
            form.addListener(this)
            this.documentDataForm$.next(form)
          } else {
            this.loadDocumentData(objectId, documentId)
              .subscribe((element: any) => {
                if (!element) return this.router.navigate(['..'], {relativeTo: this.route})
                const context = this.settingsService.selectedUserContext$.value
                const district = new HuntingDistrict(context)
                district.setFromAny(element)
                const form = new HuntingDistrictForm(
                  "HuntingDistrictForm",
                  // context.settingsMap,
                  district,
                )
                form.addListener(this)
                this.documentDataForm$.next(form)
              })
          }
        }
        break
      }
      case NetworkConstants.COLLECTION_TROPHY: {
        if (!documentId) {
          // this.loadListData(contextId, objectId)
          //   .subscribe((data) => {this.listItems$.next(data)})
          const listwithLimit = this.loadListDataWithLimit(contextId, objectId)
          .pipe(takeUntil(this.destroy$)).subscribe( )

          this.subscriptions.set(objectId, listwithLimit)

          this.listItemsTroph$
          .pipe(skipWhile((el) => !el),takeUntil(this.destroy$) )
          .subscribe(items => {
            // console.log(items?.length,'----> update listItemsTroph ---> inject comp' )
            this.listItems$.next(items)
          });
        } else {
          const huntingDistricts = this.allowedHuntingDistrictsFor(contextId, await this.huntingDistrictService.huntindDistrictSubject$.pipe(skipWhile(el => !el), take(1)).toPromise())
          this.loadDocumentData(objectId, documentId)
              .subscribe((element: any) => {
                if (!element) return this.router.navigate(['..'], {relativeTo: this.route})
                const context = this.settingsService.selectedUserContext$.value
                const trophy = new Trophy(context)
                trophy.setFromAny(element)
                const form = new TrophyForm(
                  "trophyForm",
                  context.settingsMap,
                  huntingDistricts,
                  trophy,
                )
                form.addListener(this)
                this.documentDataForm$.next(form)
              })
        }
        break
      }
      case NetworkConstants.COLLECTION_DIGATAG: {
        if (!documentId) {
          // this.loadListData(contextId, objectId)
          //   .subscribe((data) => {this.listItems$.next(data)})
          const listwithLimit = this.loadListDataWithLimit(contextId, objectId)
          .pipe(takeUntil(this.destroy$)).subscribe( )

          this.subscriptions.set(objectId, listwithLimit)

          this.listItemsDigaTag$
          .pipe(skipWhile((el) => !el),takeUntil(this.destroy$) )
          .subscribe(items => {
            // console.log(items?.length,'----> update listItemsDigTag ---> inject comp' )
            this.listItems$.next(items)
          });
        } else {
          // kommt nicht vor, da klick auf digatag zu evt. vorhandenem GameRecord navigiert.
        }        
        break
      }
      case NetworkConstants.COLLECTION_LIFE_SIGN: {
        if (!documentId) {
          this.loadListData(contextId, objectId)
            .subscribe((data) => {this.listItems$.next(data)})
        } else {
          // kommt nicht vor, da klick auf digatag zu evt. vorhandenem GameRecord navigiert.
        }        
        break
      }

    } 
  }


  removeSubs( objectId){
    if (this.subscriptions.get(objectId)){
      switch(objectId) {
        case NetworkConstants.COLLECTION_PERSON: {
          this.listItemsPerson$.unsubscribe();
          break;
        }
        case NetworkConstants.COLLECTION_EVENT: {
          this.listItemsEvent$.unsubscribe();
          break;
        }
        case NetworkConstants.COLLECTION_GAMERECORD: {
          this.listItemsGR$.unsubscribe();
          break;
        }
        case NetworkConstants.COLLECTION_GAME_COLLECT_STATION: {
          this.listItemsGCS$.unsubscribe();
          break;
        }
  
        case NetworkConstants.COLLECTION_POI: {
          this.listItemsPOI$.unsubscribe();
          break;
        }
  
        case NetworkConstants.COLLECTION_USER: {
          break;
        }
        case NetworkConstants.COLLECTION_LABSAMPLE: {
          this.listItemsLabSamp$.unsubscribe();
          break;
        }
        case NetworkConstants.COLLECTION_HUNTING_DISTRICT: {
          this.listItemsHD$.unsubscribe();
          break;
        }
        case NetworkConstants.COLLECTION_TROPHY: {
          this.listItemsTroph$.unsubscribe();
          break;
        }
        case NetworkConstants.COLLECTION_DIGATAG: {
          this.listItemsDigaTag$.unsubscribe()
          break;
        }
        case NetworkConstants.COLLECTION_LIFE_SIGN: {
          this.listItemsLifeSign$.unsubscribe()
          break;
        }
      }
    }
    this.subscriptions.forEach(element => {
      element.unsubscribe()
    });
  }

  private static readonly RIGHTS_MANAGED_COLLECTIONS: string[] = [
    NetworkConstants.COLLECTION_POI,
    NetworkConstants.COLLECTION_GAMERECORD,
    NetworkConstants.COLLECTION_WORK_ORDER,
    NetworkConstants.COLLECTION_HUNTING_DISTRICT,
    NetworkConstants.COLLECTION_LABSAMPLE,
    NetworkConstants.COLLECTION_PERSON,
    NetworkConstants.COLLECTION_USER,
  ]

  private currentUserDoc: any = undefined

  private currentRights(): any {
    const ctxId = this.subbedContext?.identifier
      ?? this.settingsService.selectedUserContext$?.value?.identifier
    return ctxId ? this.settingsService.rightsPercontext.get(ctxId) : undefined
  }

  private hasRight(rights: any, objectId: string, action: 'C'|'R'|'U'|'D'): boolean {
    if (!ComponentHandlerComponent.RIGHTS_MANAGED_COLLECTIONS.includes(objectId)) return true
    if (!rights) return true
    return !!rights?.[objectId]?.[action]
  }

  private filterUsersByRights(items: ListItem[]): ListItem[] {
    const filters = this.currentRights()?.[NetworkConstants.COLLECTION_USER]?.filters
    if (!filters?.length) return items ?? []

    const me: any = this.currentUserDoc
    const myGroups = new Set<string>((me?.userGroupIds ?? []) as string[])
    const myRoles  = new Set<string>((me?.roles ?? this.subbedContext?.roles ?? []) as string[])

    const rolesOf = (user: any): string[] =>
      user?.contextMembership?.[this.subbedContext?.identifier]?.roles ?? user?.roles ?? []


    return (items ?? []).filter(item => {
      const user: any = item?.data
      if (!user) return false
      if (filters.includes('sameUserGroup')
        && (user.userGroupIds ?? []).some((g: string) => myGroups.has(g))) return true
      if (filters.includes('sameRoles')
        && rolesOf(user).some((r: string) => myRoles.has(r))) return true
      return false
    })
  }

  private deleteCollectionFor(item: any): string | undefined {
    if (item instanceof PointOfInterestForm) return NetworkConstants.COLLECTION_POI
    if (item instanceof LaboratorySampleForm) return NetworkConstants.COLLECTION_LABSAMPLE
    if (item instanceof GenericListItem && this.activeObjectId$.value === NetworkConstants.COLLECTION_USER) {
      return NetworkConstants.COLLECTION_USER
    }
    return item?.name
  }

  private isCreatedBySelf(doc: any): boolean {
    const uid = this.subbedContext?.userId
    if (!uid) return false
    return doc?.createdByUserId === uid || doc?.createdUserId === uid
  }

  setListItems(objectId, items, contextId){
    this.rawItems.set(objectId, items)
    const rights = this.settingsService.rightsPercontext.get(contextId)
    const allowedHDIds = rights?.[NetworkConstants.COLLECTION_HUNTING_DISTRICT]?.filters

    switch(objectId) {
      case NetworkConstants.COLLECTION_PERSON: {
        this.listItemsPerson$.next(items)
        break;
      }
      case NetworkConstants.COLLECTION_EVENT: {
        this.listItemsEvent$.next(items)
        break;
      }
      case NetworkConstants.COLLECTION_GAMERECORD: {
        const filters = rights?.[NetworkConstants.COLLECTION_GAMERECORD]?.filters
        if(filters) {
          if(filters.includes(CREATED_BY_USER)) {
            items = items.filter( it => this.isCreatedBySelf(it?.data))
          }
        }
        items = applyHuntingDistrictRightsFilter<any>(items, allowedHDIds, it => it.data?.huntingDistrictId)
        this.listItemsGR$.next(items)
        break;
      }
      case NetworkConstants.COLLECTION_GAME_COLLECT_STATION: {
        this.listItemsGCS$.next(items)
        break;
      }

      case NetworkConstants.COLLECTION_POI: {
        const allFilters = rights?.[NetworkConstants.COLLECTION_POI]?.filters
        if(allFilters) {
          if (allFilters.includes(LINKED_IN_WORK_ORDERS)) {
            this.rebuildLinkedIds()
            const linked = this.linkedIdsByType.geoObject
            items = items.filter( it => linked.has(it.data?.identifier) )
          }

          const filters = allFilters.filter(f => f !== LINKED_IN_WORK_ORDERS)
          if (filters.length) {
            if (filters.includes('withoutCategory')) {
              if (filters?.length > 1) {
                items = items.filter( it => !it.data.category ||
                  Array.isArray(it.data.category) ? it.data?.category?.some(item => filters.includes(item)) : filters.includes( it.data?.category) )
              }

              if (filters?.length === 1) {
                items = items.filter( it => !it.data.category )
              }
            } else {
              if (filters?.length >= 1) {
                items = items.filter( it => Array.isArray(it.data.category) ? it.data?.category?.some(item => filters.includes(item)) : filters.includes( it.data?.category))
              }
            }
          }
        }
        items = applyHuntingDistrictRightsFilter<any>(items, allowedHDIds, it => it.data?.huntingDistrictId)
        this.listItemsPOI$.next(items)
        break;
      }

      case NetworkConstants.COLLECTION_USER: {
        break
      }
      case NetworkConstants.COLLECTION_LABSAMPLE: {
        const labFilters = rights?.[NetworkConstants.COLLECTION_LABSAMPLE]?.filters
        if (labFilters?.includes(CREATED_BY_USER)) {
          items = items.filter( it => this.isCreatedBySelf(it?.data))
        }
        items = applyHuntingDistrictRightsFilter<any>(items, allowedHDIds, it => it.data?.huntingDistrictId)
        this.listItemsLabSamp$.next(items)
        break;
      }
      case NetworkConstants.COLLECTION_HUNTING_DISTRICT: {
        items = applyHuntingDistrictRightsFilter<any>(items, allowedHDIds, it => it.data?.identifier)
        this.listItemsHD$.next(items)
        break;
      }
      case NetworkConstants.COLLECTION_TROPHY: {
        this.listItemsTroph$.next(items)
        break;
      }
      case NetworkConstants.COLLECTION_DIGATAG: {
        this.listItemsDigaTag$.next(items)
        break;
      }
      case NetworkConstants.COLLECTION_LIFE_SIGN: {
        this.listItemsLifeSign$.next(items)
        break;
      }
    }
  }

  getListItems(objectId){
    switch(objectId) {
      case NetworkConstants.COLLECTION_PERSON: {
        return this.listItemsPerson$.value;
      }
      case NetworkConstants.COLLECTION_EVENT: {
        return this.listItemsEvent$.value;
      }
      case NetworkConstants.COLLECTION_GAMERECORD: {
        return this.listItemsGR$.value;
      }
      case NetworkConstants.COLLECTION_GAME_COLLECT_STATION: {
        return this.listItemsGCS$.value;
      }

      case NetworkConstants.COLLECTION_POI: {
        return this.listItemsPOI$.value;
      }

      case NetworkConstants.COLLECTION_USER: {
        break;
      }
      case NetworkConstants.COLLECTION_LABSAMPLE: {
        return this.listItemsLabSamp$.value;
      }
      case NetworkConstants.COLLECTION_HUNTING_DISTRICT: {
        return this.listItemsHD$.value;
      }
      case NetworkConstants.COLLECTION_TROPHY: {
        return this.listItemsTroph$.value;
      }
      case NetworkConstants.COLLECTION_DIGATAG: {
        return this.listItemsDigaTag$.value;
      }
      case NetworkConstants.COLLECTION_LIFE_SIGN: {
        return this.listItemsLifeSign$.value
      }
    }
  }

  // load data for list of users
  private userContextIds(contextId: string, context: any): string[] {
    // const subIds: string[] = context?.subContextIds ?? []
    const subIds = this.settingsService.getSubcontextIds() ?? []
    return [...new Set([contextId, ...subIds].filter(Boolean))]
  }

  /**
   * Deliberately NOT gated on `settingsService.superContext` — that's a separate BehaviorSubject
   * set once during route resolution, which goes stale if the admin switches into a supercontext
   * without a full page reload (same bug fixed for the sightings map layer and the user-form
   * Kontext-Rollen section this session). `subContextIds` is read fresh off the actual current
   * context object every time, so having sub-contexts is what actually makes this a supercontext.
   */
  private isCurrentContextSuper(): boolean {
    return !!(this.settingsService.selectedUserContext$?.value as any)?.subContextIds?.length
  }

  /**
   * Chip label for a user row: only when the currently selected context is a supercontext
   * (so own-context vs. sub-context users need to be told apart) and the user's own context
   * differs from the one currently selected — shows that sub-context's name.
   */
  private subContextChipFor(userContextId: string | undefined): string | undefined {
    if (!this.isCurrentContextSuper()) return undefined
    const currentContextId = this.settingsService.selectedUserContext$?.value?.identifier
    if (!userContextId || userContextId === currentContextId) return undefined
    return this.settingsService.allUserContexts$?.value?.find(c => c.identifier === userContextId)?.contextName
  }

  private chunkIds(ids: string[]): string[][] {
    const CHUNK_SIZE = 30
    const unique = [...new Set((ids ?? []).filter(Boolean))]
    const chunks: string[][] = []
    for (let i = 0; i < unique.length; i += CHUNK_SIZE) chunks.push(unique.slice(i, i + CHUNK_SIZE))
    return chunks
  }

  loadUsersListDataFromContextMembership(contextIds: string[], objectId: string): Observable<any[]> {

    const collRef = collectionGroup(this.Ifirestore, `${NetworkConstants.COLLECTION_CONTEXT_MEMBERSHIP}`)
    const queries = this.chunkIds(contextIds).map(chunk => query(collRef, chunk.length == 1
      ? where("identifier", "==", chunk[0])
      : where("identifier", "in", chunk)))

    return from( Promise.all(queries.map(q => getDocs(q)))).pipe(
      map((snapshots:any[]) => {
        let list: ListItem[] = []

        const seen = new Set<string>()

        snapshots.flatMap(snapshot => snapshot?.docs ?? []).forEach((element: any) => {
            const data = element.data()
            const userId = data?.userId
            var listItem: ListItem|GenericListItem|undefined = undefined

            if(!userId || seen.has(userId)) return
            seen.add(userId)

            const alreadyInList = this.allUsersList?.find( user => user.data.identifier == userId)
            if(!alreadyInList){
              this.loadDocumentData(NetworkConstants.COLLECTION_USER, userId)
                .subscribe((data: any) => {
                  if(data){
                    if(!data.identifier)
                      data.identifier = userId
                    const user = anyToUser(data)
                    let subtitle //= user.email

                    if(user.invitationState && user.invitationState != 'accepted')
                      subtitle = user.invitationState
                    else
                      subtitle = user?.email
                    
                    listItem = new GenericListItem(
                      user.displayName ?? user?.email,
                      "",
                      user,
                      subtitle,
                      this.subContextChipFor((user as any)?.contextId)
                    );

                    listItem.addListener(this)
                    list.push(listItem)
                    this.allUsersList.push(listItem)
                    this.listMembershipsOfContextId$.next(this.allUsersList)
                  }
                })
            }

          });

        return list
      })
    )
  }

  loadUsersListData(contextIds: string[], obejctId){
    const collRef = collection(this.Ifirestore, obejctId)

    const queries = this.chunkIds(contextIds).flatMap(chunk => chunk.length == 1
      ? [query(collRef, or(
          where('contextId', '==', chunk[0]),
          where('contextIds', 'array-contains', chunk[0]),
        ))]
      : [
          query(collRef, where('contextId', 'in', chunk)),
          query(collRef, where('contextIds', 'array-contains-any', chunk)),
        ])

    return from( Promise.all(queries.map(q => getDocs(q)))).pipe(
      map((snapshots:any[]) => {
        let list: ListItem[] = []
        // The same user can satisfy more than one of the queries above.
        const seen = new Set<string>()

        snapshots.flatMap(snapshot => snapshot?.docs ?? []).forEach((element: any) => {
            const data = element.data()
            if(!data.identifier)
              data.identifier = element.id
            var listItem: ListItem|GenericListItem|undefined = undefined

            if(seen.has(data.identifier)) return
            seen.add(data.identifier)

            const alreadyInList = this.allUsersList?.find( user => user.data.identifier == data.identifier)
            if(!alreadyInList){
            //   if(data?.contextId == contextId || data?.contextIds?.includes(contextId) || (data?.contextMembership ? Object.keys(data.contextMembership).includes(contextId) : false) ){
                const user = anyToUser(data)
                let subtitle //= user.email

                if(user.invitationState && user.invitationState != 'accepted')
                  subtitle = user.invitationState
                else
                  subtitle = user?.email
                
                listItem = new GenericListItem(
                  user.displayName ?? user?.email,
                  "", user, subtitle,
                  this.subContextChipFor((user as any)?.contextId)
                );
                
                listItem.addListener(this)
                list.push(listItem)
                this.allUsersList.push(listItem)
                this.listMembershipsOfContextId$.next(this.allUsersList)
            //   }
            }
          });

        this.userFeedbackService.loading.emit(false)
        return list
      })
    )
  }

  // load data for list
  loadListData(contextId: string, objectId: string): Observable<any[]> {
    this.userFeedbackService.loading.emit(true)
    // let query = this.firestore.collection(objectId, ref => ref.where("contextId", "==", contextId)).get()

    const collRef = collection(this.Ifirestore, `${objectId}`)
    let q = query(collRef, where("contextId", "==", contextId))
    let queryResults = getDocs(q)

    switch(objectId) {
      case(NetworkConstants.COLLECTION_LIFE_SIGN): {
        const filterDateTwoWeeksPrior = getCurrentJagdJahr()
        // query = this.firestore.collection(objectId, ref => ref.where("contextId", "==", contextId).where('updateTimestamp', '>', filterDateTwoWeeksPrior.start).orderBy('updateTimestamp', 'desc')).get()

        const collRef = collection(this.Ifirestore, `${objectId}`)
        q = query(collRef, where("contextId", "==", contextId),
          where('updateTimestamp', '>', filterDateTwoWeeksPrior.start),
          orderBy('updateTimestamp', 'desc'))
        queryResults = getDocs(q)
      }
    }
    

    return from(queryResults).pipe(
      mergeMap(el => {

        if (el.empty) {
          this.userFeedbackService.loading.emit(false)
          return of([])
        }
        let list: any[] = []
        el.docs.forEach((element) => {
          if(objectId == NetworkConstants.COLLECTION_USER ){
            let data:any = element.data()
            if(!data.identifier)
              data.identifier = element.id
            
            list.push(data)
          }else{
          list.push(element.data())
          }
        })
        return of(list)
      }),
      take(1),
      map((_list: any[]) => {
        let list: ListItem[] = []
        _list.forEach(async (element: any) => {
          // any to user? 
          var listItem: ListItem|GenericListItem|undefined = undefined
          if (objectId == NetworkConstants.COLLECTION_GAMERECORD) {
            const gr = new GameRecord(this.settingsService.selectedUserContext$.value)
            gr.setFromAny(element)
            listItem = new GameRecordListItem(
              "title",
              "",
              gr
            )
          } else if (objectId == NetworkConstants.COLLECTION_USER) {
            // const user = anyToUser(element)
            // listItem = new GenericListItem(
            //   user.displayName ?? user?.email, 
            //   "",
            //   user
            // );
            var listItem: ListItem|GenericListItem|undefined = undefined

               const user = anyToUser(element)
               let subtitle
                if(!element.displayName){
                  subtitle = user?.email ? user.invitationState : undefined
                }else
                subtitle = user?.email
              listItem = new GenericListItem(
                user.displayName ?? user?.email, 
                "",
                user,
                subtitle
              );
              listItem.addListener(this)
            list.push(listItem)
            this.allUsersList.push(listItem)
            this.listMembershipsOfContextId$.next(this.allUsersList)


          } else if (objectId == NetworkConstants.COLLECTION_PERSON) {
            const person = new Person()
            person.setFromAny(element)
            listItem = new SelectableListItem(
              person.anzeigeName,
              NetworkConstants.COLLECTION_PERSON,
              person,
              NavListItemComponent,
            );
            (listItem as SelectableListItem).displayDelete = true;
            (listItem as SelectableListItem).onDeleteListItem = (identifier: string) => { 
              this.onDelete(listItem)
            };
          } else if (objectId == NetworkConstants.COLLECTION_EVENT) {
            const event = new HuntingEvent()
            event.setFromAny(element)
            listItem = new GenericListItem(
              event.name,
              "",
              event
            )
          } else if (objectId == NetworkConstants.COLLECTION_LABSAMPLE) {
            const labSample = new LaboratorySample(this.settingsService.selectedUserContext$.value)
            labSample.setFromAny(element)
            listItem = new SelectableListItem(
              labSample.getTypeTitle(),
              NetworkConstants.COLLECTION_LABSAMPLE,
              labSample,
              NavListItemComponent,
              labSample.materialID
            )
          } else if (objectId == NetworkConstants.COLLECTION_HUNTING_DISTRICT) {
            const district = new HuntingDistrict(this.settingsService.selectedUserContext$.value)
            district.setFromAny(element)
            listItem = new SelectableListItem(
              district.getListItemTitle(),
              NetworkConstants.COLLECTION_HUNTING_DISTRICT,
              district,
              NavListItemComponent,
              district.county
            );
            (listItem as SelectableListItem).displayEditPolygon = true
          } else if (objectId == NetworkConstants.COLLECTION_GAME_COLLECT_STATION) {
            const gameCollectStation = new GameCollectStation()
            gameCollectStation.setFromAny(element)
            listItem = new SelectableListItem(
              gameCollectStation.name,
              NetworkConstants.COLLECTION_GAME_COLLECT_STATION,
              gameCollectStation,
              NavListItemComponent,
              gameCollectStation.huntingDistrictName
            );
            (listItem as SelectableListItem).displayDelete = true;
            (listItem as SelectableListItem).onDeleteListItem = (identifier: string) => { 
              this.onDelete(listItem)
            };
          } else if (objectId == NetworkConstants.COLLECTION_POI) {
            const poi = new PointOfInterest(this.settingsService.selectedUserContext$.value)

            poi.setFromAny(element)

            var poiIconName="no_icon",iconSvgName="undefined"

            if(poi.type){
              const geObjectType = this.allGeoTypes?.find( geot => geot.identifier?.toLowerCase()==poi.type?.toLowerCase() && poi.typeTitle== geot.title)
              if(geObjectType){
                if(!geObjectType.iconName){
                  poiIconName = "undefined"
                }else{
                  poiIconName = geObjectType.iconName
                }
                iconSvgName = DefaultIconsPoiMapping.get(poiIconName)
              }

            }

            const ct = poi['contentType']
            if(ct){
              if(ct.toLowerCase() == 'line' || ct.toLowerCase() == 'polygon')
                iconSvgName = undefined
            }

            listItem = new PoiListItem(
              "title",
              "",
              poi,
              // poi.getIconName()
              iconSvgName
            )
            
          } else if (objectId == NetworkConstants.COLLECTION_TROPHY) {
            const trophy = new Trophy(this.settingsService.selectedUserContext$.value)
            trophy.setFromAny(element)
            listItem = new SelectableListItem(
              trophy.getTypeTitle(),
              NetworkConstants.COLLECTION_TROPHY,
              trophy,
              NavListItemComponent,
              trophy.tagID
            );
            (listItem as SelectableListItem).displayDelete = true;
            (listItem as SelectableListItem).onDeleteListItem = (identifier: string) => { 
              this.onDelete(listItem)
            };
          } else if (objectId == NetworkConstants.COLLECTION_DIGATAG) {
            const tag = new Digatag()
            tag.setFromAny(element)
            let subtitle = (tag?.governmentId ?? '') + ' ' + (tag.state ?? '' )
            listItem = new SelectableListItem(
              tag.identifier,
              NetworkConstants.COLLECTION_TROPHY,
              tag,
              NavListItemComponent,
              subtitle//`${tag.governmentId ?? undefined} ${tag.state}`
            )
          } else if (objectId == NetworkConstants.COLLECTION_LIFE_SIGN) {
            const lifeSign = new LifeSign()
            lifeSign.setFromAny(element)
            listItem = new GenericListItemDisabled(
              lifeSign.getListItemTitle(),
              NetworkConstants.COLLECTION_LIFE_SIGN,
              lifeSign,
              lifeSign.getListItemSubTitle(this.translateService.getBrowserLang(), undefined)
            )
      
          }

          if (objectId != NetworkConstants.COLLECTION_USER) {
            listItem.addListener(this)
            list.push(
              listItem
            )
            this.userFeedbackService.loading.emit(false)
          }else{
            this.userFeedbackService.loading.emit(false)

          }

        });
        return list
      }
    ))
  }

  async loadListDataContextAndContextIds(contextId: string, objectId: string, context) {//Observable<any[]>
    const contextIds = this.settingsService.getSubcontextIds()//    ?? context?.subContextIds

    // console.log('--- loadListDataContextAndContextIds --- ',objectId, contextId, contextIds)
    this.userFeedbackService.loading.emit(true)
    const CHUNK_SIZE = 30;
    const qy$ = [];
    const collRef = collection(this.Ifirestore, `${objectId}`)

    qy$.push(getDocs(query(collRef, where('contextId', '==', contextId))));
    qy$.push(getDocs(query(collRef, where('contextIds', 'array-contains', contextId))));


    if (contextIds?.length != 0) {
      for (let i = 0; i < contextIds.length; i += CHUNK_SIZE) {
        const chunk = contextIds.slice(i, i + CHUNK_SIZE);
        const q = query(
          collRef, or( 
            where("contextId", "in", chunk)
          )
        )
        qy$.push( getDocs(q) );
      }
    }

    const snapshots = await Promise.all(qy$);

    let list: ListItem[] = []
    const seen = new Set<string>();

    snapshots.flatMap(snapshot => {
      if (snapshot.empty ) { return [] }
      let lists: any[] = []
      snapshot.docs.forEach((element) => {
        if(objectId == NetworkConstants.COLLECTION_USER ){
          let data:any = element.data()
          if(!data.identifier) data.identifier = element.id
          
          lists.push(data)
        }else
        lists.push(element.data())
      })
      return lists
    })
    .filter(({ identifier }) => {
      if (!identifier || seen.has(identifier)) {
        console.log('Duplicate removed:', identifier);
        return false;
      }
  
      seen.add(identifier);
      return true;
    })
    .map((element: any[]) => {
      var listItem: ListItem|undefined = undefined

      if (objectId == NetworkConstants.COLLECTION_GAMERECORD) {
        const gr = new GameRecord(this.settingsService.selectedUserContext$.value)
        gr.setFromAny(element)
        listItem = new GameRecordListItem(
          "title",
          "",
          gr
        )
      } else if (objectId == NetworkConstants.COLLECTION_LABSAMPLE) {
        const labSample = new LaboratorySample(this.settingsService.selectedUserContext$.value)
        labSample.setFromAny(element)
        listItem = new SelectableListItem(
          labSample.getTypeTitle(),
          NetworkConstants.COLLECTION_LABSAMPLE,
          labSample,
          NavListItemComponent,
          labSample.materialID
        )
      } else if (objectId == NetworkConstants.COLLECTION_POI) {
        const poi = new PointOfInterest(this.settingsService.selectedUserContext$.value)
        poi.setFromAny(element)
        var poiIconName="no_icon",iconSvgName="undefined"

        if(poi.type){
          const geObjectType = this.allGeoTypes?.find( geot => geot.identifier?.toLowerCase()==poi.type?.toLowerCase() && poi.typeTitle== geot.title)
          if(geObjectType){
            if(!geObjectType.iconName)
              poiIconName = "undefined"
            else
              poiIconName = geObjectType.iconName
            
            iconSvgName = DefaultIconsPoiMapping.get(poiIconName)
          }
        }

        const ct = poi['contentType']
        if(ct){
          if(ct.toLowerCase() == 'line' || ct.toLowerCase() == 'polygon')
            iconSvgName = undefined
        }

        listItem = new PoiListItem(
          "title",
          "",
          poi,
          iconSvgName
        )
        
      } else if (objectId == NetworkConstants.COLLECTION_HUNTING_DISTRICT) {
        const district = new HuntingDistrict(this.settingsService.selectedUserContext$.value)
        district.setFromAny(element)
        listItem = new SelectableListItem(
          district.getListItemTitle(),
          NetworkConstants.COLLECTION_HUNTING_DISTRICT,
          district,
          NavListItemComponent,
          district.county
        );
        (listItem as SelectableListItem).displayEditPolygon = true
      }
      listItem.addListener(this)
      list.push(listItem)
      this.userFeedbackService.loading.emit(false)
    });

    this.setListItems(objectId, list, contextId)
    return list
  }

  // load data for list with pagination(limit=500, startAt=doc)
  loadListDataWithLimit(contextId:string, objectId:string, startDoc?:any): Observable<any[]>{//
    // console.log('****--loadListDataWithLimit--****', contextId, objectId, startDoc?.id)
    let LIMIT = 500

    const collRef = collection(this.Ifirestore, `${objectId}`)
    let q = query(collRef, where("contextId", "==", contextId), limit(LIMIT))
    let lastDoc = startDoc || null;

    let activeObjectId = this.activeObjectId$.value
    this.documentDataForm$
    .pipe(skipWhile((el) => !el))
    .subscribe ( value => {
      // console.log(value, '----should stop this call----')

      if(value){
        return;
      }
    })


    this.activeObjectId$
    .pipe(skipWhile((el) => !el))
    .subscribe ( value => {
      if(value ){
        activeObjectId = value
        if(value != objectId){
          const listitems = this.getListItems(objectId)
          // console.log(value, '----objectId updated----> stop subscription',listitems?.length , listitems?.length!=0 ? listitems[0] : 'empt-y',)//this.listItemsWithLimit$.value?.length
          this.loadingPagination = false
          if(this.subscriptions.get(objectId)) this.subscriptions.get(objectId).unsubscribe()
          this.userFeedbackService.loading.emit(true)
          return;
        }
      }
    })

    switch(objectId) {
      case(NetworkConstants.COLLECTION_LIFE_SIGN): {
        const filterDateTwoWeeksPrior = getCurrentJagdJahr()

        q = query(collRef, where("contextId", "==", contextId),
          where('updateTimestamp', '>', filterDateTwoWeeksPrior.start),
          orderBy('updateTimestamp', 'desc'),  limit(LIMIT))
      }
    }
    
    if(lastDoc){

      q = query(collRef, where("contextId", "==", contextId),
        startAfter(lastDoc),
        limit(LIMIT))

        switch(objectId) {
          case(NetworkConstants.COLLECTION_LIFE_SIGN): {
            const filterDateTwoWeeksPrior = getCurrentJagdJahr()
            q = query(collRef, where("contextId", "==", contextId),
              where('updateTimestamp', '>', filterDateTwoWeeksPrior.start),
              startAfter(lastDoc),
              orderBy('updateTimestamp', 'desc'),  
              limit(LIMIT))
          }
        }
    }else{
      this.userFeedbackService.loading.emit(true)
      this.setListItems(objectId, [], contextId)
    }

    const current = this.getListItems(objectId)

    while(this.actualActiveObjectId === objectId){
      let queryResults = getDocs(q)

      this.loadingPagination = true
        
      return from(queryResults).pipe(
        mergeMap((el:any) => {
          if (el.empty ) {
            this.userFeedbackService.loading.emit(false)
            return of([])
          }
  
          let list: any[] = []
          const lastItem = this.lastListItem$.value
          lastItem[objectId] = el.docs[el.docs.length-1]
          this.lastListItem$.next(lastItem)
          el.docs.forEach((element) => {
            if(objectId == NetworkConstants.COLLECTION_USER ){
              let data:any = element.data()
              if(!data.identifier)
                data.identifier = element.id
              
              list.push(data)
            }else
              list.push(element.data())
          })
  
          return of(list)
        }),
        take(1),
        map((_list: any[]) => {
          let list: ListItem[] = []
          _list.forEach(async (element: any) => {
            // any to user? 
            var listItem: ListItem|GenericListItem|undefined = undefined
            if (objectId == NetworkConstants.COLLECTION_GAMERECORD) {
              const gr = new GameRecord(this.settingsService.selectedUserContext$.value)
              gr.setFromAny(element)
              listItem = new GameRecordListItem(
                "title",
                "",
                gr
              )
            } else if (objectId == NetworkConstants.COLLECTION_USER) {
  
              var listItem: ListItem|GenericListItem|undefined = undefined
  
                 const user = anyToUser(element)
                 let subtitle
                  if(!element.displayName){
                    subtitle = user?.email ? user.invitationState : undefined
                  }else
                  subtitle = user?.email
                listItem = new GenericListItem(
                  user.displayName ?? user?.email, 
                  "",
                  user,
                  subtitle
                );
                listItem.addListener(this)
              list.push(listItem)
              this.allUsersList.push(listItem)
              this.listMembershipsOfContextId$.next(this.allUsersList)
  
  
            } else if (objectId == NetworkConstants.COLLECTION_PERSON) {
              const person = new Person()
              person.setFromAny(element)
              listItem = new SelectableListItem(
                person.anzeigeName,
                NetworkConstants.COLLECTION_PERSON,
                person,
                NavListItemComponent,
              );
              (listItem as SelectableListItem).displayDelete = true;
              (listItem as SelectableListItem).onDeleteListItem = (identifier: string) => { 
                this.onDelete(listItem)
              };
            } else if (objectId == NetworkConstants.COLLECTION_EVENT) {
              const event = new HuntingEvent()
              event.setFromAny(element)
              listItem = new GenericListItem(
                event.name,
                "",
                event
              )
            } else if (objectId == NetworkConstants.COLLECTION_LABSAMPLE) {
              const labSample = new LaboratorySample(this.settingsService.selectedUserContext$.value)
              labSample.setFromAny(element)
              listItem = new SelectableListItem(
                labSample.getTypeTitle(),
                NetworkConstants.COLLECTION_LABSAMPLE,
                labSample,
                NavListItemComponent,
                labSample.materialID
              )
            } else if (objectId == NetworkConstants.COLLECTION_HUNTING_DISTRICT) {
              const district = new HuntingDistrict(this.settingsService.selectedUserContext$.value)
              district.setFromAny(element)
              listItem = new SelectableListItem(
                district.getListItemTitle(),
                NetworkConstants.COLLECTION_HUNTING_DISTRICT,
                district,
                NavListItemComponent,
                district.county
              );
              (listItem as SelectableListItem).displayEditPolygon = true
            } else if (objectId == NetworkConstants.COLLECTION_GAME_COLLECT_STATION) {
              const gameCollectStation = new GameCollectStation()
              gameCollectStation.setFromAny(element)
              listItem = new SelectableListItem(
                gameCollectStation.name,
                NetworkConstants.COLLECTION_GAME_COLLECT_STATION,
                gameCollectStation,
                NavListItemComponent,
                gameCollectStation.huntingDistrictName
              );
              (listItem as SelectableListItem).displayDelete = true;
              (listItem as SelectableListItem).onDeleteListItem = (identifier: string) => { 
                this.onDelete(listItem)
              };
            } else if (objectId == NetworkConstants.COLLECTION_POI) {
              const poi = new PointOfInterest(this.settingsService.selectedUserContext$.value)
              poi.setFromAny(element)
  
              var poiIconName="no_icon",iconSvgName="undefined"
  
              if(poi.type){
                const geObjectType = this.allGeoTypes?.find( geot => geot.identifier?.toLowerCase()==poi.type?.toLowerCase() && poi.typeTitle== geot.title)
                if(geObjectType){
                  if(!geObjectType.iconName)
                    poiIconName = "undefined"
                  else
                    poiIconName = geObjectType.iconName
                  
                  iconSvgName = DefaultIconsPoiMapping.get(poiIconName)
                }
  
              }
  
              const ct = poi['contentType']
              if(ct){
                if(ct.toLowerCase() == 'line' || ct.toLowerCase() == 'polygon')
                  iconSvgName = undefined
              }
  
              listItem = new PoiListItem(
                "title",
                "",
                poi,
                // poi.getIconName()
                iconSvgName
              )
              
            } else if (objectId == NetworkConstants.COLLECTION_TROPHY) {
              const trophy = new Trophy(this.settingsService.selectedUserContext$.value)
              trophy.setFromAny(element)
              listItem = new SelectableListItem(
                trophy.getTypeTitle(),
                NetworkConstants.COLLECTION_TROPHY,
                trophy,
                NavListItemComponent,
                trophy.tagID
              );
              (listItem as SelectableListItem).displayDelete = true;
              (listItem as SelectableListItem).onDeleteListItem = (identifier: string) => { 
                this.onDelete(listItem)
              };
            } else if (objectId == NetworkConstants.COLLECTION_DIGATAG) {
              const tag = new Digatag()
              tag.setFromAny(element)
              let subtitle = (tag?.governmentId ?? '') + ' ' + (tag.state ?? '' )
              listItem = new SelectableListItem(
                tag.identifier,
                NetworkConstants.COLLECTION_TROPHY,
                tag,
                NavListItemComponent,
                subtitle//`${tag.governmentId ?? undefined} ${tag.state}`
              )
            } else if (objectId == NetworkConstants.COLLECTION_LIFE_SIGN) {
              const lifeSign = new LifeSign()
              lifeSign.setFromAny(element)
              listItem = new GenericListItemDisabled(
                lifeSign.getListItemTitle(),
                NetworkConstants.COLLECTION_LIFE_SIGN,
                lifeSign,
                lifeSign.getListItemSubTitle(this.translateService.getBrowserLang(), undefined)
              )
        
            }
  
            if (objectId != NetworkConstants.COLLECTION_USER) {
              listItem.addListener(this)
              list.push(listItem)
              this.userFeedbackService.loading.emit(false)
            }else
              this.userFeedbackService.loading.emit(false)
  
          });
          return list
        }), 
        tap((all) => {
  
          // if(activeObjectId === objectId){

            const allitems = [...current ?? [], ...all]
            if(all.length < LIMIT){
              this.loadingPagination = false
              this.lastListItem$.value[objectId] = undefined
              // this.listItemsWithLimit$.next(allitems);
              this.setListItems(objectId, allitems, contextId)
            }
            else{
              // this.listItemsWithLimit$.next(allitems);
              this.setListItems(objectId, allitems, contextId)

              if(this.subscriptions.get(objectId))
              this.subscriptions.get(objectId).unsubscribe()

              const a = this.loadListDataWithLimit(contextId, objectId, this.lastListItem$.value[objectId])
                ?.pipe(takeUntil(this.destroy$), takeUntil(this.objectIdChange$)).subscribe( value=> {})

              this.subscriptions.set(objectId,a)
            }
          // }
          
        }))
    }
    
  }

  get actualActiveObjectId() {
    return this.activeObjectId$.value
  }  

  checkIfDocExists(collection: string,docId: string, subcollection: string, subcollectionId: string ): Observable<boolean> {
    // const docRef = this.firestore.collection(collection).doc(docId).collection(subcollection).doc(subcollectionId).get()

    const docRef = doc(this.Ifirestore, `${collection}/${docId}/${subcollection}/${subcollectionId}`)
    return from(getDoc(docRef)).pipe(
      map(docSnapshot => docSnapshot.exists())
    );
  }
  // load data for specific document
  loadDocumentData(objectId: string, documentId: string): Observable<any|undefined> {
    // return this.firestore.collection(objectId).doc(documentId).get().pipe(map(el => {}))

    const ref = doc(this.Ifirestore, `${objectId}/${documentId}`);
    return from(getDoc(ref)).pipe(
      map(el => {
        if (el.exists()) return el.data()
        else undefined
      }),
      catchError(error => {
        console.error( `${objectId}/${documentId}`, error);
        return throwError(() => error);
      })
    )
  }

  // Callback for list items (ListItemListener)
  async onClick(item: ListItem) {
    const activeId = this.activeObjectId$.value
    if (activeId === NetworkConstants.COLLECTION_USER || activeId === NetworkConstants.COLLECTION_PERSON || activeId === NetworkConstants.COLLECTION_EVENT) {
      this.openGridItemFormDialog(activeId, item.data?.identifier)
      return
    }
    this.userFeedbackService.loading.emit(true)
    switch(item.data?.className) {
      case(Digatag.className): {
        const tag = item.data as Digatag
        if (tag.state == 'inUse' && tag.gameRecordId) {
          // navigate to game record
          this.userFeedbackService.loading.emit(false)
          this.router.navigate(['../', NetworkConstants.COLLECTION_GAMERECORD, tag.gameRecordId], {relativeTo: this.route})
        } else {
          // do nothing
          const txt = this.translateService.instant('snack_no_gr_present')
          this.userFeedbackService.showSnackBar.emit(txt)
        }
        break 
      }
      case(NetworkConstants.COLLECTION_LIFE_SIGN): {
        
        break
      }
      default: {
        this.userFeedbackService.loading.emit(false)
        this.router.navigate([item.data.identifier], {relativeTo: this.route})
      }
    }
  }

  async onDelete(item: ListItem|GenericListItem|SelectableListItem) {
    const collection = this.deleteCollectionFor(item)
    if (collection && !this.hasRight(this.currentRights(), collection, 'D')) {
      this.showNoRightsDialog()
      return
    }

    let operation: Promise<void>|null = null
    if (item instanceof SelectableListItem) {
      if (item.name == NetworkConstants.COLLECTION_PERSON) {
        operation = this.personService.deletePerson(item.data)
      } else if (item.name == NetworkConstants.COLLECTION_GAME_COLLECT_STATION) {
        operation = this.gameCollectStationService.deleteGameCollectStation(item.data)
      } else if (item.name == NetworkConstants.COLLECTION_TROPHY) {
        operation = this.trophyService.deleteTrophy(item.data)
      } 
  }
    if (item instanceof PointOfInterestForm) {///we have to put it like these because the NetworkConstants.Collection_POI and the NetworkConstants.Collection_POIntOfinterest = "PointOfInterest" and not poiform

    // if (item.name == "poiForm") {///we have to put it like these because the NetworkConstants.Collection_POI and the NetworkConstants.Collection_POIntOfinterest = "PointOfInterest" and not poiform
    operation = this.poiService.deletePointOfInterest(item.data)
      // this.onCancle
    }


    if (item.name == NetworkConstants.COLLECTION_GAMERECORD) {
     
      operation = this.gamerecordService.deleteGameRecord(item.data)
    } 


    if(item instanceof ListItem){
    }

    if(item instanceof GenericListItem){
      if (this.activeObjectId$.value === NetworkConstants.COLLECTION_USER) {
        operation = this.userService.deleteUser(item.data)
      }
    }

    if(item instanceof LaboratorySampleForm){
      operation = this.labSampleService.deleteLabSample(item.data)
    }
    
    if (operation == null) return
    try {
      this.userFeedbackService.loading.emit(true)
      await operation
    } catch(error) {
      console.error(error)
    } finally {
      this.userFeedbackService.loading.emit(false)
      // this.reloadData(item.name)
      this.onCancle(this.activeForm)
    }
  }

  reloadData(objectId) {
    this.loadListData(this.settingsService.selectedUserContext$.value.identifier, objectId)
      .subscribe((data) => {this.listItems$.next(data)})
  }

  // form callbacks
  onCancle(form: Form) {
    this.router.navigate(['..'], {relativeTo: this.route})
  }
  onSuccessfullySubmitted(form: Form) {
    this.router.navigate(['..'], {relativeTo: this.route})
  }

  /** Hunting districts a form's district picker may offer, per the role's HuntingDistrict rights filter. */
  private allowedHuntingDistrictsFor(contextId: string, huntingDistricts: any[]): any[] {
    const allowedHDIds = this.settingsService.rightsPercontext.get(contextId)?.[NetworkConstants.COLLECTION_HUNTING_DISTRICT]?.filters
    return applyHuntingDistrictRightsFilter(huntingDistricts ?? [], allowedHDIds, (d: any) => d?.identifier)
  }

  private ensureUserGroupsLoaded(): void {
    if (this.usGroupService.allAssignableUserGroupsSubject$.value) return
    const ctx = this.settingsService.selectedUserContext$?.value
    this.usGroupService.observeDataGroups(ctx?.identifier)
  }

  private groupNameById(id: string): string | undefined {
    return (this.usGroupService.allAssignableUserGroupsSubject$.value ?? []).find((g: any) => g.identifier === id)?.name
  }

  private static readonly FIXED_ROLE_LABEL_KEYS: Record<string, string> = {
    [UserRoles.ANSTELLER]:    'FORM.userForm.roleAnsteller',
    [UserRoles.JAGDLEITER]:   'FORM.userForm.roleJagdleiter',
    [UserRoles.USER]:         'FORM.userForm.roleUser',
    [UserRoles.HUNTER]:       'FORM.userForm.roleHunter',
    [UserRoles.REVIERLEITER]: 'FORM.userForm.roleRevierLeiter',
    [UserRoles.RECORDER]:     'FORM.userForm.roleRecorder',
    [UserRoles.APPVET]:       'FORM.userForm.roleAppVet',
    [UserRoles.VETHDLEADER]:  'FORM.userForm.roleVetHDLeader',
    [UserRoles.ADMIN]:        'FORM.userForm.roleAdmin',
    [UserRoles.CADAVERSEEK]:  'FORM.userForm.roleCadaverSeek',
    [UserRoles.CADAVERBT] :   'FORM.userForm.roleCadaverBT',
    [UserRoles.STAFF]:        'FORM.userForm.roleStaff',
    [UserRoles.SENIOR]:       'FORM.userForm.roleSenior'

  }

  /** Resolves a stored role identifier (e.g. "jagdleiter", or a custom role's identifier) to its display title, same as the roles checkboxes in user-form. */
  private roleLabel(id: string): string {
    const key = ComponentHandlerComponent.FIXED_ROLE_LABEL_KEYS[id]
    if (key) return this.translateService.instant(key)

    const rawValues = this.settingsService.selectedUserContext$?.value?.settingsMap?.get(NetworkConstants.SETTING_USER_ROLES)?.values
    const customRoles = rawValues && isArray(rawValues) ? rawValues : []
    return customRoles.find((r: any) => r.identifier === id)?.title ?? id
  }

  /**
   * Roles are per-context now (see user-form's "Kontext-Rollen" section) — a user's flat `roles`
   * field only reflects their HOME context, so the grid can't just always show that: a supercontext
   * admin also sees sub-context users (via the chip column) who may have no role at all in the
   * context currently being viewed. Resolve against whichever context this list is actually for.
   */
  private rolesForCurrentContext(user: any): string[] {
    const currentContextId = this.settingsService.selectedUserContext$?.value?.identifier
    if (!currentContextId) return []
    return user?.contextMembership?.[currentContextId]?.roles ?  user?.contextMembership?.[currentContextId]?.roles : (user.roles ?? [])
  }

  private userGridColumnDefs(): any[] {
    const cols: any[] = [
      { field: 'title', headerName: this.translateService.instant('FORM.speciesForm.name'), flex: 1.5 },
    ]

    if (this.isCurrentContextSuper()) {
      cols.push({
        colId: 'subContext',
        headerName: this.translateService.instant('COCKPIT.SETTINGS.userContext'),
        flex: 1,
        valueGetter: (p: any) => this.subContextChipFor(p.data?.raw?.contextId) ?? '',
        cellRenderer: (p: any) => p.value
          ? `<span style="padding:1px 8px;border-radius:999px;background:#f2f2f2;color:#666;font-size:11px;font-weight:500;white-space:nowrap;">${p.value}</span>`
          : '',
      })
    }

    cols.push(
      { colId: 'firstName', headerName: this.translateService.instant('FORM.personForm.vorname'), flex: 1, valueGetter: (p: any) => p.data?.raw?.firstName ?? '' },
      { colId: 'lastName', headerName: this.translateService.instant('FORM.personForm.nachname'), flex: 1, valueGetter: (p: any) => p.data?.raw?.lastName ?? '' },
      { colId: 'email', headerName: this.translateService.instant('FORM.userForm.email'), flex: 1.5, valueGetter: (p: any) => p.data?.raw?.email ?? '' },
      {
        colId: 'roles',
        // In a supercontext, roles shown here are only for the context currently being viewed
        // (see rolesForCurrentContext) — a user can have entirely different roles per sub-context,
        // so make that scoping explicit in the header rather than let it read as "all their roles".
        headerName: this.isCurrentContextSuper()
          ? this.translateService.instant('COCKPIT.SETTINGS.userRolesCurrentContext')
          : this.translateService.instant('COCKPIT.SETTINGS.userRoles'),
        flex: 1.5,
        valueGetter: (p: any) => this.rolesForCurrentContext(p.data?.raw).map((id: string) => this.roleLabel(id)).join(', '),
      },
      {
        colId: 'groups', headerName: this.translateService.instant('LINK.UserGroup'), flex: 1.5,
        valueGetter: (p: any) => ((p.data?.raw?.userGroupIds ?? []) as string[])
          .map((id: string) => this.groupNameById(id))
          .filter(Boolean)
          .join(', '),
      },
    )

    return cols
  }

  private personGridColumnDefs(): any[] {
    return [
      { field: 'title', headerName: this.translateService.instant('FORM.personForm.anzeigeName'), flex: 1.5 },
      { colId: 'firstName', headerName: this.translateService.instant('FORM.personForm.vorname'), flex: 1, valueGetter: (p: any) => p.data?.raw?.vorname ?? '' },
      { colId: 'lastName', headerName: this.translateService.instant('FORM.personForm.nachname'), flex: 1, valueGetter: (p: any) => p.data?.raw?.nachname ?? '' },
      { colId: 'email', headerName: this.translateService.instant('FORM.personForm.emailAddresse'), flex: 1.5, valueGetter: (p: any) => p.data?.raw?.emailAddresse ?? '' },
      { colId: 'zip', headerName: this.translateService.instant('FORM.personForm.zip'), width: 100, valueGetter: (p: any) => p.data?.raw?.legalPersonalAddress?.zip ?? '' },
      { colId: 'city', headerName: this.translateService.instant('FORM.personForm.city'), flex: 1, valueGetter: (p: any) => p.data?.raw?.legalPersonalAddress?.city ?? '' },
      { colId: 'comment', headerName: this.translateService.instant('FORM.personForm.kommentar'), flex: 1.5, valueGetter: (p: any) => p.data?.raw?.kommentar ?? '' },
    ]
  }

  private eventGridColumnDefs(): any[] {
    return [
      { field: 'title', headerName: this.translateService.instant('FORM.personForm.anzeigeName'), flex: 1.5 },
      { colId: 'name', headerName: this.translateService.instant('FORM.huntingEventForm.name'), flex: 1, valueGetter: (p: any) => p.data?.raw?.name ?? '' },
      { colId: 'date', headerName: this.translateService.instant('FORM.huntingEventForm.date'), flex: 1, valueGetter: (p: any) => p.data?.raw?.date ?? '' },
      { colId: 'active', headerName: this.translateService.instant('FORM.huntingEventForm.active'), flex: 1, valueGetter: (p: any) => p.data?.raw?.active ?? false },
      { colId: 'comment', headerName: this.translateService.instant('FORM.huntingEventForm.comment'), flex: 1, valueGetter: (p: any) => p.data?.raw?.comment ?? '' },
      { colId: 'huntingDistricts', headerName: this.translateService.instant('FORM.gameCollectForm.huntingDistrict'), flex: 1, valueGetter: (p: any) => p.data?.raw?.huntingDistricts ?? '' },
    ]
  }

  private async openGridItemFormDialog(objectId: string, documentId: string | undefined): Promise<void> {
    let form: Form
    const title = this.translateService.instant(`COCKPIT.OBJECTS.${objectId}`)

    const event = objectId === NetworkConstants.COLLECTION_EVENT
    if (objectId === NetworkConstants.COLLECTION_USER) {
      if (!documentId) {
        form = new InviteUserForm('Create User', undefined)
      } else {
        const element: any = await this.loadDocumentData(objectId, documentId).pipe(take(1)).toPromise()
        if (!element) return
        if (!element.identifier) element.identifier = documentId
        form = new UserForm('UserForm', anyToUser(element))
      }
    } else if (objectId === NetworkConstants.COLLECTION_PERSON) {
      if (!documentId) {
        form = new PersonForm('Create Person', undefined)
      } else {
        const element: any = await this.loadDocumentData(objectId, documentId).pipe(take(1)).toPromise()
        if (!element) return
        const person = new Person()
        person.setFromAny(element)
        form = new PersonForm('PersonForm', person)
      }
    } else if (objectId === NetworkConstants.COLLECTION_EVENT) {
      const huntingDistricts = this.allowedHuntingDistrictsFor(this.settingsService.selectedUserContext$.value?.identifier, await this.huntingDistrictService.huntindDistrictSubject$.pipe(skipWhile(el => !el), take(1)).toPromise())

      if (!documentId) {
        form = new HuntingEventForm( "Create Event", huntingDistricts, undefined )      
      } else {
        const element: any = await this.loadDocumentData(objectId, documentId).pipe(take(1)).toPromise()
        if (!element) return

        const event = new HuntingEvent()
        event.setFromAny(element)
        form = new HuntingEventForm( "Event", huntingDistricts, event )
      }
    }

    const dialogRef = this.dialog.open(FormDialogComponent, {
      data: { form, objectService: event ? this.eventsService : this.personService, title },
      maxWidth: '700px',
    })

    dialogRef.afterClosed().subscribe((saved: boolean) => {
      if (saved) {
        this.userNameLookup.refreshAllUsers();
        this.currentObjectId.next(this.route.snapshot.url)
      }
    })
  }

  navBack() {
    if (this.activeForm.onNavBack) this.activeForm.onNavBack()
    else this.router.navigate(['..'], {relativeTo: this.route})
  }

  openDialogVets(list){
    //--------------states
    this.allStates = this.huntingDistrictService.allStates$.value ? Object.values(this.huntingDistrictService.allStates$.value) : undefined
    if(!this.allStates)
      this.huntingDistrictService.getStatesList()

    let items = list?.filter(vet => vet.huntingDistrictList === true)?.sort((a,b) => a?.name?.localeCompare(b.name));//

    const dialogRef = this.dialog.open( HuntingDistrictListDialogComponent, {
      data: { items }
    });
    
    dialogRef.afterClosed().subscribe(async result => {
      if(!result) return
      // let obj = dataToObject(result)
      let obj = result
      obj.contextId = this.route.snapshot.parent.parent.paramMap.get('contextId')

      if(obj.state)
        obj.stateCode = this.allStates?.find(state => state.name === obj.state)?.isoCode

      this.showCreate = false
      this.showBack = true

      // obj.templateId = obj.id
      const user = await this.userService.user$.pipe(take(1)).toPromise()
      obj.createdByUserName = user.displayName
      obj.createdByUserId = user.identifier
      const district = new HuntingDistrict()
      district.setFromAny(obj)

      try{
        const newHD = deepCopy(district)
        const cleaned = removeUndefined(newHD)
        this.userFeedbackService.loading.emit(true)
        const id = await this.huntingDistrictService.createDistrict(cleaned, obj.identifier)
        this.userFeedbackService.loading.emit(false)

        if(result.outline){
          const outlines = this.createOutlineDataFromString(obj.outline)
          obj.outline = outlines
          cleaned.identifier = id
          await this.huntingDistrictService.createOutline(cleaned, obj.outline)
        }

        const sbSuccessSave = this.translateService.instant('successfully_created')
        this.userFeedbackService.showSnackBar.emit(sbSuccessSave)
        this.router.navigate([id], {relativeTo: this.route})
      }catch(e) {
        console.log(e)
      }
    })
  }

  createOutlineDataFromString(str){
    var geometry = {  };
    if (str) {
      const encodedContent = str.split(" ");
      let pairs;
      pairs = encodedContent.reduce(function (result, value, indexV, array) {
        if (indexV % 2 === 0) {
            const splited = array.slice(indexV, indexV + 2);
            var lat = +splited[0];
            var lng = +splited[1];
            result.push(lat+"|"+lng);
        }
        return result;
      }, []);
      geometry = {
        contextId: this.subbedContext.identifier,
        creationDate: new Date(),
        huntingDistrictId: undefined,
        identifier: undefined,
        polygon:{
          coordinates: pairs
        },
        updateTimestamp: new Date(),
      };
    }
    return geometry;
  }

  showNoRightsDialog(){
    const title = this.translateService.instant('title_no_access')
    const message = this.translateService.instant('msg_no_access')
    this.userFeedbackService.showDialog.emit({
      title,
      message,
      entryComponent: GenericDialogComponent
    })
  }

}